import { CloseCircleFilled, CloseOutlined } from "@ant-design/icons";

type ErrorType =
  | "FILE_NOT_PDF"
  | "FILE_NOT_READABLE"
  | "INVALID_PDF_FORMAT"
  | "PDF_IS_PASSWORD_PROTECTED"
  | "FILE_SIZE_NOT_RETRIEVABLE"
  | "DUPLICATE"
  | "SIZE_LIMIT_EXCEEDED"
  | "PROJECT_LIMIT_EXCEEDED";
type ErrorCode = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export type TExtractionUploadErrorMessages = {
  error_type: ErrorType;
  error_code: ErrorCode;
  error: string;
  id: string;
  fileName?: string;
  totalPages?: number | undefined;
  processedPages?: number | undefined;

  current_usage?: number;
  total_limit?: number;
  remaining_pages?: number;
  percent_consumed?: number;
  pages_to_process?: number;
};

function getErrorMessage(errorInfo: TExtractionUploadErrorMessages) {
  switch (errorInfo.error_type) {
    case "PROJECT_LIMIT_EXCEEDED": {
      const pagesToProcessLabel =
        errorInfo?.pages_to_process === 1 ? "page" : "pages";
      const remainingPagesLabel =
        errorInfo?.remaining_pages === 1 ? "page" : "pages";

      return (
        <div>
          <p>
            This file contains {errorInfo?.pages_to_process}{" "}
            {pagesToProcessLabel} which exceeds the remaining page processing
            limit of {errorInfo?.remaining_pages} {remainingPagesLabel}. Contact
            Support (
            <a href="mailto:support@constructiviq.com">
              support@constructiviq.com
            </a>
            ) to increase your limit.
          </p>
        </div>
      );
    }
    default:
      return errorInfo.error;
  }
}

export default function ExtractionUploadErrorAlert({
  errorInfo,
  onClose
}: {
  errorInfo: TExtractionUploadErrorMessages;
  onClose: (id: string) => void;
}) {
  return (
    <div className="flex space-x-2 border border-solid border-ciq-red-200 bg-ciq-red-50 rounded-lg p-3">
      <div>
        <CloseCircleFilled className="text-ciq-error-500 hover:text-ciq-error-500" />
      </div>
      <div className="text-xs text-black text-opacity-90">
        {getErrorMessage(errorInfo)}
      </div>
      <div>
        <CloseOutlined
          size={12}
          onClick={() => onClose(errorInfo.id)}
          className="cursor-pointer text-black text-opacity-50 hover:text-black hover:text-opacity-100 text-xs"
        />
      </div>
    </div>
  );
}
